module.exports = new __parcel__URL__("les-concerts-en-chine.814d0e5f.jpg").toString();